export default "__VITE_ASSET__NabKQqfq__"